<app-dashboard-layout [loading]="loading">
  <app-notification-alert [data]="notification"></app-notification-alert>

  <section *ngIf="refreshing" class="grid gap-4 grid-cols-1 sm:grid-cols-2 md:gap-6 lg:grid-cols-3 xl:grid-cols-4">
    <div *ngFor="let i of [1,2,3,4]" class="bg-white rounded-md border-2 p-6 animate-pulse">
      <div class="rounded-full bg-gray-300 h-16 w-16"></div>
      <div class="bg-gray-300 rounded h-5 mt-4 w-3/4"></div>
      <div class="bg-gray-200 rounded h-3 mt-2 w-full"></div>
    </div>
  </section>

  <section *ngIf="!refreshing" class="grid gap-4 grid-cols-1 sm:grid-cols-2 md:gap-6 lg:grid-cols-3 xl:grid-cols-4">
    <app-dashboard-card *ngFor="let link of links" [routerLink]="link.slug" [title]="link.title" [icon]="link.icon"
      [caption]="link.text"></app-dashboard-card>
  </section>
</app-dashboard-layout>
